import XLSX from 'xlsx'
//
export default {
    methods:{
        /* 
        *
        */
        generateXLSX (data,headers,nameFile) {
            var ws = XLSX.utils.json_to_sheet(data, {header:headers})
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook,ws,'hoja1')
            XLSX.writeFile(workbook, `${nameFile}.xlsx`);
        },
    }
}
